const headerImageUrl =
  'https://picsum.photos/seed/autorply-mobile-flow-header/1200/630';

const carouselImageUrls = [
  'https://picsum.photos/seed/autorply-mobile-card-1/1200/630',
  'https://picsum.photos/seed/autorply-mobile-card-2/1200/630',
  'https://picsum.photos/seed/autorply-mobile-card-3/1200/630',
  'https://picsum.photos/seed/autorply-mobile-card-4/1200/630',
  'https://picsum.photos/seed/autorply-mobile-card-5/1200/630',
];

const startNode = ({ id, title, triggerKeywords, position }) => ({
  id,
  type: 'start',
  label: title,
  config: {
    title,
    matchType: 'exact',
    webhookUrl: '',
    assignedAgentId: '',
    triggerKeywords,
  },
  message: '',
  summary: triggerKeywords,
  position,
  condition: '',
});

const noMatchNode = ({ id, title, position }) => ({
  id,
  type: 'noMatch',
  label: title,
  config: {
    title,
  },
  message: '',
  summary: title,
  position,
  condition: '',
});

const interactiveHeader = () => ({
  enabled: true,
  type: 'media',
  text: '',
  mediaType: 'image',
  mediaSource: 'link',
  mediaLink: headerImageUrl,
  mediaUrl: headerImageUrl,
  mediaId: '',
  blobId: '',
  blobKey: '',
  contentType: 'image/jpeg',
  fileSize: 0,
  fileName: 'header.jpg',
});

const interactiveNode = ({ id, body, footer = '', position }) => ({
  id,
  type: 'interactive',
  label: 'Interactive',
  config: {
    body,
    footer,
    typingOnDisplay: false,
    delay: { seconds: 0, minutes: 0, hours: 0 },
    header: interactiveHeader(),
  },
  message: body,
  summary: body,
  position,
  condition: '',
});

const buttonNode = ({ id, title, position }) => ({
  id,
  type: 'button',
  label: 'Button',
  config: {
    title,
    payload: `button_${id}`,
    nextStepType: 'message',
    linkedFlowId: '',
    addLabelIds: [],
    removeLabelIds: [],
  },
  message: '',
  summary: title,
  position,
  condition: '',
});

const textNode = ({ id, body, position }) => ({
  id,
  type: 'text',
  label: 'Text Message',
  config: {
    header: '',
    body,
    footer: '',
  },
  message: body,
  summary: body,
  position,
  condition: '',
});

const keyboardNode = ({ id, buttonText, position }) => ({
  id,
  type: 'keyboard',
  label: 'Keyboard',
  config: { buttonText },
  message: '',
  summary: buttonText,
  position,
  condition: '',
});

const sectionNode = ({ id, title, position }) => ({
  id,
  type: 'section',
  label: 'Section',
  config: { title },
  message: '',
  summary: title,
  position,
  condition: '',
});

const rowNode = ({ id, title, description, position }) => ({
  id,
  type: 'row',
  label: 'Row',
  config: {
    title,
    payload: `row_${id}`,
    description,
  },
  message: '',
  summary: title,
  position,
  condition: '',
});

const carouselCard = ({ body, mediaUrl, buttonText, buttonUrl }) => ({
  body,
  mediaType: 'image',
  mediaSource: 'link',
  mediaLink: mediaUrl,
  mediaUrl,
  blobId: '',
  blobKey: '',
  contentType: 'image/jpeg',
  fileSize: 0,
  fileName: '',
  buttonText,
  buttonUrl,
  quickReplies: [],
});

const carouselNode = ({ id, body, cards, position }) => ({
  id,
  type: 'carousel',
  label: 'Interactive Carousel',
  config: {
    body,
    actionType: 'url',
    cards,
  },
  message: body,
  summary: `${body} · ${cards.length} cards · URL`,
  position,
  condition: '',
});

const connection = ({
  id,
  source,
  target,
  sourceOutput,
  targetInput = 'reply',
}) => ({
  id,
  source,
  sourceOutput,
  target,
  targetInput,
});

const welcomeTemplateDefinition = labels => ({
  version: 1,
  nodes: [
    noMatchNode({
      id: 'no_match_welcome',
      title: labels.noMatchTitle,
      position: { x: 120, y: 120 },
    }),
    interactiveNode({
      id: 'interactive_welcome',
      body: 'مرحبًا بك، اختر أحد الخيارات التالية للمتابعة.',
      footer: 'يمكنك تعديل هذا النموذج قبل النشر',
      position: { x: 470, y: 120 },
    }),
    buttonNode({
      id: 'button_about',
      title: 'نبذة عنا',
      position: { x: 860, y: 20 },
    }),
    buttonNode({
      id: 'button_services',
      title: 'خدماتنا',
      position: { x: 860, y: 180 },
    }),
    buttonNode({
      id: 'button_contact',
      title: 'تواصل معنا',
      position: { x: 860, y: 340 },
    }),
    textNode({
      id: 'text_about',
      body: 'هذه رسالة تعريفية عن الشركة، استبدلها بمحتواك الحقيقي.',
      position: { x: 1220, y: 0 },
    }),
    textNode({
      id: 'text_services',
      body: 'هذه رسالة تعريفية بالخدمات أو المنتجات الأساسية.',
      position: { x: 1220, y: 160 },
    }),
    textNode({
      id: 'text_contact',
      body: 'هذه رسالة توضح طريقة التواصل أو التحويل إلى فريق الدعم.',
      position: { x: 1220, y: 320 },
    }),
  ],
  connections: [
    connection({
      id: 'welcome_entry',
      source: 'no_match_welcome',
      sourceOutput: 'next',
      target: 'interactive_welcome',
    }),
    connection({
      id: 'welcome_button_about',
      source: 'interactive_welcome',
      sourceOutput: 'buttons',
      target: 'button_about',
    }),
    connection({
      id: 'welcome_button_services',
      source: 'interactive_welcome',
      sourceOutput: 'buttons',
      target: 'button_services',
    }),
    connection({
      id: 'welcome_button_contact',
      source: 'interactive_welcome',
      sourceOutput: 'buttons',
      target: 'button_contact',
    }),
    connection({
      id: 'welcome_about_next',
      source: 'button_about',
      sourceOutput: 'next',
      target: 'text_about',
    }),
    connection({
      id: 'welcome_services_next',
      source: 'button_services',
      sourceOutput: 'next',
      target: 'text_services',
    }),
    connection({
      id: 'welcome_contact_next',
      source: 'button_contact',
      sourceOutput: 'next',
      target: 'text_contact',
    }),
  ],
});

const chatbotButtonsDefinition = labels => ({
  version: 1,
  nodes: [
    startNode({
      id: 'start_buttons',
      title: labels.startTitle,
      triggerKeywords: 'buttons',
      position: { x: 120, y: 120 },
    }),
    interactiveNode({
      id: 'interactive_buttons',
      body: 'اختر من القائمة السريعة التالية.',
      footer: 'نموذج تجريبي جاهز للتعديل',
      position: { x: 470, y: 120 },
    }),
    buttonNode({
      id: 'button_orders',
      title: 'الطلبات',
      position: { x: 860, y: 20 },
    }),
    buttonNode({
      id: 'button_hours',
      title: 'ساعات العمل',
      position: { x: 860, y: 180 },
    }),
    buttonNode({
      id: 'button_support',
      title: 'الدعم',
      position: { x: 860, y: 340 },
    }),
    textNode({
      id: 'text_orders',
      body: 'هذه رسالة متابعة للطلبات أو الشحن أو حالة الطلب.',
      position: { x: 1220, y: 0 },
    }),
    textNode({
      id: 'text_hours',
      body: 'هذه رسالة متابعة لساعات العمل أو أوقات التوفر.',
      position: { x: 1220, y: 160 },
    }),
    textNode({
      id: 'text_support',
      body: 'هذه رسالة متابعة للدعم أو التواصل مع الفريق.',
      position: { x: 1220, y: 320 },
    }),
  ],
  connections: [
    connection({
      id: 'buttons_entry',
      source: 'start_buttons',
      sourceOutput: 'next',
      target: 'interactive_buttons',
    }),
    connection({
      id: 'buttons_orders',
      source: 'interactive_buttons',
      sourceOutput: 'buttons',
      target: 'button_orders',
    }),
    connection({
      id: 'buttons_hours',
      source: 'interactive_buttons',
      sourceOutput: 'buttons',
      target: 'button_hours',
    }),
    connection({
      id: 'buttons_support',
      source: 'interactive_buttons',
      sourceOutput: 'buttons',
      target: 'button_support',
    }),
    connection({
      id: 'buttons_orders_next',
      source: 'button_orders',
      sourceOutput: 'next',
      target: 'text_orders',
    }),
    connection({
      id: 'buttons_hours_next',
      source: 'button_hours',
      sourceOutput: 'next',
      target: 'text_hours',
    }),
    connection({
      id: 'buttons_support_next',
      source: 'button_support',
      sourceOutput: 'next',
      target: 'text_support',
    }),
  ],
});

const chatbotListDefinition = labels => ({
  version: 1,
  nodes: [
    startNode({
      id: 'start_list',
      title: labels.startTitle,
      triggerKeywords: 'list',
      position: { x: 120, y: 120 },
    }),
    interactiveNode({
      id: 'interactive_list',
      body: 'اختر الخدمة التي تريد معرفة المزيد عنها.',
      footer: 'هذا نموذج قائمة جاهز للتعديل',
      position: { x: 470, y: 120 },
    }),
    keyboardNode({
      id: 'keyboard_list',
      buttonText: 'عرض الخدمات',
      position: { x: 860, y: 120 },
    }),
    sectionNode({
      id: 'section_services',
      title: 'خدماتنا',
      position: { x: 1220, y: 120 },
    }),
    rowNode({
      id: 'row_brand',
      title: 'تصميم الهوية البصرية',
      description: 'محتوى توضيحي للخدمة',
      position: { x: 1560, y: 0 },
    }),
    rowNode({
      id: 'row_social',
      title: 'إدارة حسابات التواصل',
      description: 'محتوى توضيحي للخدمة',
      position: { x: 1560, y: 120 },
    }),
    rowNode({
      id: 'row_ads',
      title: 'إعلانات ممولة',
      description: 'محتوى توضيحي للخدمة',
      position: { x: 1560, y: 240 },
    }),
    rowNode({
      id: 'row_web',
      title: 'تصميم وتطوير المواقع',
      description: 'محتوى توضيحي للخدمة',
      position: { x: 1560, y: 360 },
    }),
    rowNode({
      id: 'row_consulting',
      title: 'استشارات تسويقية',
      description: 'محتوى توضيحي للخدمة',
      position: { x: 1560, y: 480 },
    }),
    textNode({
      id: 'text_brand',
      body: 'هذه رسالة متابعة للخدمة الأولى، بدّلها بالمحتوى الحقيقي.',
      position: { x: 1920, y: 0 },
    }),
    textNode({
      id: 'text_social',
      body: 'هذه رسالة متابعة للخدمة الثانية، بدّلها بالمحتوى الحقيقي.',
      position: { x: 1920, y: 120 },
    }),
    textNode({
      id: 'text_ads',
      body: 'هذه رسالة متابعة للخدمة الثالثة، بدّلها بالمحتوى الحقيقي.',
      position: { x: 1920, y: 240 },
    }),
    textNode({
      id: 'text_web',
      body: 'هذه رسالة متابعة للخدمة الرابعة، بدّلها بالمحتوى الحقيقي.',
      position: { x: 1920, y: 360 },
    }),
    textNode({
      id: 'text_consulting',
      body: 'هذه رسالة متابعة للخدمة الخامسة، بدّلها بالمحتوى الحقيقي.',
      position: { x: 1920, y: 480 },
    }),
  ],
  connections: [
    connection({
      id: 'list_entry',
      source: 'start_list',
      sourceOutput: 'next',
      target: 'interactive_list',
    }),
    connection({
      id: 'list_keyboard',
      source: 'interactive_list',
      sourceOutput: 'list',
      target: 'keyboard_list',
    }),
    connection({
      id: 'list_section',
      source: 'keyboard_list',
      sourceOutput: 'sections',
      target: 'section_services',
    }),
    connection({
      id: 'list_row_brand',
      source: 'section_services',
      sourceOutput: 'rows',
      target: 'row_brand',
    }),
    connection({
      id: 'list_row_social',
      source: 'section_services',
      sourceOutput: 'rows',
      target: 'row_social',
    }),
    connection({
      id: 'list_row_ads',
      source: 'section_services',
      sourceOutput: 'rows',
      target: 'row_ads',
    }),
    connection({
      id: 'list_row_web',
      source: 'section_services',
      sourceOutput: 'rows',
      target: 'row_web',
    }),
    connection({
      id: 'list_row_consulting',
      source: 'section_services',
      sourceOutput: 'rows',
      target: 'row_consulting',
    }),
    connection({
      id: 'list_text_brand',
      source: 'row_brand',
      sourceOutput: 'next',
      target: 'text_brand',
    }),
    connection({
      id: 'list_text_social',
      source: 'row_social',
      sourceOutput: 'next',
      target: 'text_social',
    }),
    connection({
      id: 'list_text_ads',
      source: 'row_ads',
      sourceOutput: 'next',
      target: 'text_ads',
    }),
    connection({
      id: 'list_text_web',
      source: 'row_web',
      sourceOutput: 'next',
      target: 'text_web',
    }),
    connection({
      id: 'list_text_consulting',
      source: 'row_consulting',
      sourceOutput: 'next',
      target: 'text_consulting',
    }),
  ],
});

const cardsCarouselDefinition = labels => ({
  version: 1,
  nodes: [
    startNode({
      id: 'start_cards',
      title: labels.startTitle,
      triggerKeywords: 'cards',
      position: { x: 120, y: 120 },
    }),
    carouselNode({
      id: 'carousel_cards',
      body: 'استعرض مجموعة بطاقات المنتجات أو الخدمات الجاهزة.',
      position: { x: 470, y: 120 },
      cards: [
        carouselCard({
          body: 'أثاث المنزل',
          mediaUrl: carouselImageUrls[0],
          buttonText: labels.cardCta,
          buttonUrl: 'https://example.com/furniture',
        }),
        carouselCard({
          body: 'الإلكترونيات',
          mediaUrl: carouselImageUrls[1],
          buttonText: labels.cardCta,
          buttonUrl: 'https://example.com/electronics',
        }),
        carouselCard({
          body: 'الجمال والعناية',
          mediaUrl: carouselImageUrls[2],
          buttonText: labels.cardCta,
          buttonUrl: 'https://example.com/beauty',
        }),
        carouselCard({
          body: 'المستلزمات الرياضية',
          mediaUrl: carouselImageUrls[3],
          buttonText: labels.cardCta,
          buttonUrl: 'https://example.com/sports',
        }),
        carouselCard({
          body: 'منتجات موسمية',
          mediaUrl: carouselImageUrls[4],
          buttonText: labels.cardCta,
          buttonUrl: 'https://example.com/seasonal',
        }),
      ],
    }),
  ],
  connections: [
    connection({
      id: 'cards_entry',
      source: 'start_cards',
      sourceOutput: 'next',
      target: 'carousel_cards',
    }),
  ],
});

export const mobileFlowTemplateIds = [
  'welcome_buttons',
  'chatbot_buttons',
  'chatbot_list',
  'cards_carousel',
];

export const buildMobileConversationFlowTemplate = (templateId, labels) => {
  const catalog = {
    welcome_buttons: welcomeTemplateDefinition,
    chatbot_buttons: chatbotButtonsDefinition,
    chatbot_list: chatbotListDefinition,
    cards_carousel: cardsCarouselDefinition,
  };

  return (catalog[templateId] || chatbotButtonsDefinition)(labels);
};
